import { FC } from "react";

type IProps = {
  stroke?: string;
};

const MailInvite: FC<IProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={72}
      height={70}
      viewBox="0 0 72 70"
      fill="none"
    >
      <path
        d="M1.05469 44.5233V23.6756C1.05469 21.7927 2.06859 20.0574 3.70688 19.1334L8.82703 16.2436M63.173 16.2436L68.2931 19.1334C69.0981 19.5875 69.7679 20.2474 70.234 21.0456C70.7 21.8437 70.9455 22.7514 70.9453 23.6756V63.1027C70.9453 65.9841 68.6095 68.317 65.7309 68.317H6.26906C3.39047 68.317 1.05469 65.9841 1.05469 63.1027V49.4452M24.1483 7.59741L33.437 2.3552C34.2192 1.91427 35.1019 1.68262 35.9999 1.68262C36.8978 1.68262 37.7805 1.91427 38.5627 2.3552L47.8515 7.59741M8.82703 31.493V10.6692C8.82703 8.97329 10.2037 7.59798 11.9011 7.59798H52.2745"
        stroke="#1890FF"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.0811 7.59814H60.1017C61.7963 7.59814 63.173 8.97346 63.173 10.6694V31.4931M70.9448 25.9438L44.92 44.5233M27.0804 44.5233L1.05581 25.9438M1.05469 63.1028L33.2648 40.1078C34.9017 38.9406 37.0983 38.9406 38.7338 40.1078L48.7505 47.2586M70.9453 63.1028L52.7175 50.0908M19.7356 30.9898H52.2641M25.6534 35.4664H46.3463M36.937 13.7728L38.0375 16.0027C38.1125 16.1547 38.2234 16.2861 38.3604 16.3857C38.4975 16.4853 38.6568 16.5501 38.8245 16.5745L41.2853 16.9321C42.1425 17.0567 42.4848 18.1101 41.8645 18.7147L40.0839 20.4504C39.9625 20.5687 39.8718 20.7147 39.8194 20.8758C39.767 21.037 39.7547 21.2085 39.7834 21.3755L40.2037 23.8263C40.3501 24.68 39.454 25.3311 38.6873 24.9279L36.4863 23.7707C36.3363 23.6919 36.1694 23.6507 35.9999 23.6507C35.8305 23.6507 35.6636 23.6919 35.5136 23.7707L33.3125 24.9279C32.5458 25.331 31.6498 24.68 31.7962 23.8263L32.2165 21.3755C32.2451 21.2085 32.2327 21.037 32.1804 20.8759C32.128 20.7147 32.0373 20.5687 31.916 20.4504L30.1354 18.7147C29.5151 18.11 29.8574 17.0566 30.7146 16.9321L33.1754 16.5745C33.3431 16.5502 33.5024 16.4854 33.6395 16.3858C33.7765 16.2862 33.8874 16.1547 33.9623 16.0027L35.0629 13.7728C35.4461 12.996 36.5536 12.996 36.937 13.7728Z"
        stroke="#1890FF"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MailInvite;
